module.exports = __webpack_public_path__ + "files/56ebde5a400b7a446b672862069705e2.png";